import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';


import { authRoutes } from './auth';
import { mainRoutes } from './main';
import { dashboardRoutes } from './dashboard';

// ----------------------------------------------------------------------

const Page404 = lazy(() => import('src/pages/error/404'));

export const routesSection: RouteObject[] = [
 /*{
    path: '/',

    element: (
      <Suspense fallback={<SplashScreen />}>
        <MainLayout>
          <DashboardPage />
        </MainLayout>
      </Suspense>
    ),
  },*/

  // Auth
  ...authRoutes,

  // Dashboard
  ...dashboardRoutes,

  // Main
  ...mainRoutes,

  // Components
  //...componentsRoutes,

  // No match
  { path: '*', element: <Page404 /> },
];
